import React from "react";
import "./style.scss";

function RewardTicket({ data }) {
  return (
    <div className="reward-ticket">
      <div
        style={{
          backgroundColor: data?.bg,
        }}
        className="left-section"
      >
        <span>{data?.reward_type || "REWARD"}</span>
      </div>
      <div
        style={{
          borderColor: data?.bg,
        }}
        className="right-section flex flex-col justify-center"
      >
        <span className="text-black font-title-xs fw-700 leading-4">
          {data?.username}
        </span>
        <p className="valid-date mt-1">AEC ID: {data?.aec_id}</p>
        <p className="valid-date mt-0-5 fw-600 text-primary">
          {data?.days} Days & {data?.contact} Contacts
        </p>
      </div>
    </div>
  );
}

export default RewardTicket;
